<template>
  <div class="top-bar">
    <research-report-text-list-item @noDownloadPermissions="noDownloadPermissions" :showDel="false" @uncollect="uncollect" @collection="collection" @download="download" @changeDetailStatus="changeDetailStatus" @change="change" v-for="(item, index) in data" :key="index" :data="item"></research-report-text-list-item>
  </div>
</template>

<script>
import ResearchReportTextListItem from '@/components/research-report/ResearchReportTextListItem';

export default {
  props: {
    data: {
      type: Array
    }
  },
  methods: {
    change() {
      this.$emit('change');
    },
    collection(res) {
      this.$emit('collection', res);
    },
    uncollect(res) {
      this.$emit('uncollect', res);
    },
    download(res) {
      this.$emit('download', res);
    },
    changeChecked(res) {
      this.$emit('change', res);
    },
    changeDetailStatus(id) {
      this.$emit('changeDetailStatus', id);
    },
    noDownloadPermissions() {
      this.$emit('noDownloadPermissions');
    }
  },
  components: {
    ResearchReportTextListItem
  }
};
</script>

<style lang="scss" scoped>

</style>
